var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isWebView)?_c('sidebar'):_c('burgerMenu'),_c('router-view',{staticClass:"router-view",attrs:{"id":"router-view"}}),_c('div',{staticClass:"cursor",attrs:{"id":"cursor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }